/**
 * Contains configurations for chart.js
 */

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { DoughnutText } from "app/plugins/charts/doughnut-text";

ChartJS.register(ArcElement, Tooltip, Legend, DoughnutText);
